import { useState } from "react"
import { updateApplet } from "./api"

import PushNotifications from "./config/push_notifications"
import { Activity, RecentActivity } from "./config/activity"
import { Applet } from "types"

interface TopLevelConfigProps {
  applet: Applet
  showPublishCta: boolean
  urls: {
    activityPath: string
    publishedAppletEditPath: string
  }
}

const TopLevelConfig = ({ applet, urls, showPublishCta }: TopLevelConfigProps) => {
  const { id: appletId, can_push_enable, push_enabled } = applet
  const [pushEnabled, setPushEnabled] = useState(push_enabled)

  const onPushChange = async (pushEnabled: boolean) => {
    await updateApplet({ appletId, pushEnabled })

    setPushEnabled(pushEnabled)
  }

  return (
    <>
      <RecentActivity connection={applet} />
      {applet.status == "enabled_for_user" && can_push_enable && (
        <PushNotifications onChange={onPushChange} pushEnabled={pushEnabled} />
      )}

      <Activity connection={applet} activityURL={urls.activityPath} />

      {showPublishCta ? (
        <div className="connection-view-activity">
          <div className="connection-list-activity">
            <p className="txt-body-3">Publish this Applet so anyone can use it.</p>

            <a role="button" className="button-tertiary button-outlined" href={urls.publishedAppletEditPath}>
              Publish
            </a>
          </div>
        </div>
      ) : null}
    </>
  )
}

export default TopLevelConfig
